'use client'

import { usePathname } from 'next/navigation'
import { ReactNode, useEffect, useState } from 'react'

/** Chrome gate: hides children in ?embed=1 mode and on full-screen app routes. */
const FULLSCREEN_ROUTES = ['/stream', '/labs/workspace']

export default function HideOnEmbed({ children }: { children: ReactNode }) {
  const pathname = usePathname() ?? ''
  const [embed, setEmbed] = useState(false)
  useEffect(() => {
    try { setEmbed(new URLSearchParams(window.location.search).get('embed') === '1') } catch { /* ssr */ }
  }, [pathname])
  if (embed || FULLSCREEN_ROUTES.includes(pathname)) return null
  return <>{children}</>
}
